import { render, staticRenderFns } from "./AddDCPage.vue?vue&type=template&id=8a31bd38&"
import script from "./AddDCPage.vue?vue&type=script&lang=js&"
export * from "./AddDCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports